<ng-template #template let-row="row" let-index="rowIndex">
  <div *ngIf="row?.accessToClient" class="project-client-cell">
    <contact-name *ngIf="row?.MainContact" [contact]="row?.MainContact" [placement]="'top'" [project]="row" />
  </div>
</ng-template>
